<template>
  <div>
    <FormCard
      v-model="message"
      :show-buttons="false"
      @formSubmit="$emit('formSubmit', $event)">
      <CardForm
        :resource="message"
        resource-name="message"
        :section-title="$t('payout.request')"
        :subtitle="$t('payout.payoutRequestText')">
        <input v-model="message.name" type="hidden" name="message[name]">
        <input v-model="message.email" type="hidden" name="message[email]">
        <MultilineTextInput
          v-model="message.message"
          name="message[message]"
          :custom-label="$t('payout.message')"
          :placeholder="$t('payout.optionalMessage')" />
        <input v-model="message.reason" type="hidden" name="message[reason]">
        <input v-model="merchantAccountId" type="hidden" name="message[extra_data][]">
        <input v-model="merchantAccountInfo" type="hidden" name="message[extra_data][]">
        <input v-model="merchantProfileEmailNumber" type="hidden" name="message[extra_data][]">
        <input v-model="userEmailNumber" type="hidden" name="message[extra_data][]">
      </CardForm>
      <div class="form-controls">
        <button
          type="submit"
          :disabled="submitDebounce"
          class="btn btn-form ihjoz-button ihjoz-button-big-size"
          @click="submitForm($event)">
          {{ $t('payout.requestPayout') }}
        </button>
      </div>
    </FormCard>
  </div>
</template>

<script>
import FormCard from "../UI/FormCard.vue";
import CardForm from "../UI/CardForm.vue";
import MultilineTextInput from "../UI/MultilineTextInput.vue";
import UserStore from "../../../user_dashboard/components/User/UserStore";
import CompanyStore from "../Company/CompanyStore";

export default {
  name: "PayoutForm",

  components: {
    FormCard,
    CardForm,
    MultilineTextInput
  },

  data: function () {
    return {
      user: UserStore.state.user,
      merchant: CompanyStore.state.company,
      tenant: Dashboard.currentTenant,
      submitDebounce: false
    };
  },

  computed: {
    message () {
      return { name: this.userFullName,
        email: this.userPrimaryEmail,
        reason: this.tenantizedTag
      };
    },

    userFullName () {
      return `${this.user.first_name} ${this.user.last_name}`;
    },

    userPrimaryEmail () {
      return this.user.user_emails.find(email => email.primary).email;
    },

    userNumber () {
      if (this.user.user_mobile_numbers[0]) {
        let primaryNumber = this.user.user_mobile_numbers.find(number => number.primary);

        if (primaryNumber) {
          return primaryNumber.mobile_number;
        } else {
          return this.user.user_mobile_numbers[0];
        }
      } else {
        return this.$t("payout.noMobileNumber");
      }
    },

    tenantizedTag () {
      return `${this.tenant.name} - ` + this.$t("payout.request");
    },

    merchantAccountId () {
      return `Merchant ID: ${this.merchant.id}\r\n`;
    },

    merchantAccountInfo () {
      return `Primary Contact\r\n${this.merchant.merchant_name}\r\n${this.merchant.merchant_email}\r\n${this.merchant.merchant_mobile}\r\n`;
    },

    merchantProfileEmailNumber () {
      return `Merchant Profile Email\r\n${this.merchant.email}\r\nMerchant Profile Phone Number\r\n${this.merchant.phone_number}\r\n`;
    },

    userEmailNumber () {
      return `User Email\r\n${this.userPrimaryEmail}\r\nUser Phone Number\r\n${this.userNumber}`;
    }
  },

  methods: {
    submitForm (e) {
      e.preventDefault();
      this.$emit("formSubmit", e);

      this.submitDebounce = true;
      setTimeout(() => {
        this.submitDebounce = false;
      }, 1000);
    }
  }
};
</script>
